<template>
  <ul>
    <li
      v-for="(item, index) in navList"
      :key="index"
      @click="goUrl(item, index)"
      :class="[
        idx === index ? 'sunshine-active item-li' : '',
        index === 0 ? 'disnone' : 'item-li'
      ]"
    >
      {{ item.label }}
    </li>
  </ul>
  <!-- index === 0 ? 'home' : 'item-li' -->
</template>

<script>
export default {
  props:['navList'],
  data() {
    return {
      idx: 1
    };
  },
  methods: {
    goUrl(item, index) {
      if(item.disabled)return;
      this.idx = index;
      this.$router.push(item.path);
      document.documentElement.scrollTop = 0;
    }
  },
  watch: {
    $route() {
      const path = this.$route.fullPath;
      const index = this.navList.findIndex(item => item.path === path);
      this.idx = index;
    }
  },
  created() {
    let path = "";
    path = this.$route.fullPath;
    const index = this.navList.findIndex(item => item.path === path);
    if(index!==-1){
      this.idx = index;
    }
  }
};
</script>

<style scoped>
.port-container {
  width: 1200px;
  height: 920px;
  margin: 0 auto;
  display: flex;
  padding: 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}

ul {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

ul > li {
  width: 191px;
  height: 64px;
  font-size: 24px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #34373b;
  line-height: 64px;
  margin: 2px 0;
  cursor: pointer;
  background: #eef0f4;
  margin-right: 40px;
}
ul > .sunshine-active,.item-li:hover {
  background-color: #0066b3;
  background-size: 200px 64px;
  font-size: 24px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #ffffff;
}
ul > .home {
  font-size: 28px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  background: #eaeaea;
}
.disnone{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Policies/common/menuCom.vue